import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Normalizes API responses that may be either direct arrays or paginated objects with 'items' property
 * Prevents "X.filter is not a function" errors when APIs return {items: [...]} instead of [...]
 */
export const toArray = (resp: any): any[] => {
  const arr = Array.isArray(resp) ? resp : (resp?.items ?? []);
  // Filter out any falsy/undefined entries to avoid downstream "cannot read property 'id' of undefined" errors
  return Array.isArray(arr) ? arr.filter(Boolean) : [];
}
